import { useEffect, useRef, type ReactNode } from 'react';
import type { PlayerIndex } from '@tpubg/shared';
import { PLAYER_STYLES } from '../lib/players';

/** Moves focus to the first button when an overlay appears, so Enter/Space act on it. */
export function useAutoFocus<T extends HTMLElement>(active = true) {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (active) ref.current?.focus({ preventScroll: true });
  }, [active]);
  return ref;
}

export function Countdown({ n }: { n: number }) {
  return (
    <div className="overlay overlay--clear" aria-live="assertive">
      <div className="countdown" key={n}>
        {n}
      </div>
      <p className="overlay__hint">Get ready</p>
    </div>
  );
}

export function PlayerTag({ index, name }: { index: PlayerIndex; name?: string }) {
  const style = PLAYER_STYLES[index];
  return (
    <span className={`player-tag player-tag--p${index + 1}`}>
      <span aria-hidden="true">{style.symbol}</span> {name ?? style.label}
    </span>
  );
}

interface PanelProps {
  title: ReactNode;
  children?: ReactNode;
  tone?: 'p1' | 'p2' | 'neutral';
  labelledBy?: string;
}

export function Panel({ title, children, tone = 'neutral' }: PanelProps) {
  return (
    <div className="overlay" role="dialog" aria-modal="false" aria-label={typeof title === 'string' ? title : undefined}>
      <div className={`panel panel--${tone}`}>
        <h2 className="panel__title">{title}</h2>
        {children}
      </div>
    </div>
  );
}
